export default __webpack_public_path__ + "minus.138843ee88ad30db.svg";